import {useQuery} from 'react-query'
import {parseISO} from 'date-fns'

import {api, queryClient, useMutationQuery} from 'base'
import {isBorrowerFromProfileQuery} from 'modules/profile'
import {REQUEST_APPROVED_STATUSES, REQUEST_DECLINED_STATUSES, REQUEST_CURRENT_STATUSES,} from 'modules/request'
import {showSuccessNotification} from 'common/helpers'
import {NewRequestValues} from '.'

type RequestsKeyType = 'current' | 'approved' | 'declined'

export const useGetRequests = (status: RequestsKeyType) =>
  useQuery<any>(['requests', status], async () => {
    const {data} = await api.get('/loanRequest/list', {
      params: {
        filter:
          (status === 'approved') ? {status: REQUEST_APPROVED_STATUSES}
          :
          (status === 'declined') ? {status: REQUEST_DECLINED_STATUSES}
          :
          (status === 'current') ? {status: REQUEST_CURRENT_STATUSES}
          :
          undefined,
        sort: 'createdAt',
        include: 'project',
      },
    })
    const sortedData: any[] = data.data.slice()
    sortedData.sort((a, b) => +parseISO(b.createdAt) - +parseISO(a.createdAt))
    return sortedData
  })

export const useCreateRequest = (onSuccessActions: (request: any) => void) =>
  useMutationQuery<any, any, NewRequestValues>(
    'createRequest',
    async (values: any) => {
      if (!values) return {}
      const newValues = Object.keys(values).reduce((accu: any, k:string) => {
        if (
          (values[k] === null) ||
          (values[k] === undefined)
        ) {
          return accu
        } else {
          accu[k] = values[k]
          return accu
        }
      }, ({} as any))

      const {data} = await api.post('/loanRequest/new', newValues)
      return data.data
    },
    {
      onSuccess(data) {
        const isBorrower = isBorrowerFromProfileQuery()
        queryClient.invalidateQueries(
          isBorrower ? 'projects' : ['requests', 'current']
        )
        onSuccessActions(data)
        showSuccessNotification(
          `New ${isBorrower ? 'project' : 'request'} "${
            data.project.title
          }" has been created.`
        )
      },
    }
  )
